module.exports = __webpack_public_path__ + "static/media/bogo_card_3.925f76bc.jpg";